import { useGLTF } from "@react-three/drei";
import { useLoader } from "@react-three/fiber";
import { STLLoader } from "three-stdlib";

const assetsDir = "/assets";

export const Files = {
  DRACO: {
    GLTF: `${assetsDir}/draco/gltf/`,
  },
  MODELS: {
    INSOLE: `${assetsDir}/models/Semelle_A3_High_STL_R_V2.stl`,
  },
  IMAGES: {
    LOG_IN_ILLU: `${assetsDir}/images/login-illu.png`,
    INSOLE_PREVIEW_LEFT: `${assetsDir}/images/insole-left.png`,
    INSOLE_PREVIEW_RIGHT: `${assetsDir}/images/insole-right.png`,
  },
  DEFAULT_AVATAR: `${assetsDir}/images/default-avatar.png`,
};

const preloadModels = (obj: any) => {
  Object.values(obj).forEach((value) => {
    if (typeof value === "string") {
      if (value.endsWith(".stl")) {
        useLoader.preload(STLLoader, value);
      } else if (value.endsWith(".glb") || value.endsWith(".gltf")) {
        useGLTF.preload(value);
      }
    } else if (typeof value === "object") {
      preloadModels(value);
    }
  });
};

preloadModels(Files.MODELS);
